import { Stack, Typography, Tooltip, Box, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';

type Props = {
  title: string;
  description?: string;
  padding: number;
  tooltip?: string;
  mt?: number;
  mb?: number;
  actionIcon?: React.ReactNode;
  onActionClick?: () => void;
};

export const SectionTitle = ({
  title,
  description,
  padding,
  tooltip,
  mt,
  mb,
  actionIcon,
  onActionClick,
}: Props) => {
  return (
    <Stack
      direction="column" // Stack elements vertically
      spacing={0.5} // Add spacing between title and description
      sx={{
        mt: mt || 2,
        ml: padding,
        mr: padding - 1,
        mb: mb || 2,
        '& .MuiIconButton-sizeSmall': {
          fontSize: 10,
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant="body1"
            sx={{
              textTransform: 'capitalize',
              fontFamily: 'Sohne',
              fontWeight: 500,
              fontStyle: 'Kräftig',
              fontSize: '16px',
              leadingTrim: 'NONE',
              lineHeight: '22px',
              letterSpacing: '0px'

            }}
          >
            {title}
          </Typography>
          {description && (
            <Typography
              variant="caption"
              sx={{
                ml: 1, // Add spacing between title and description
                color: 'grey.600', // Use Material-UI's grey palette for a subtle grey color
              }}
            >
              {description}
            </Typography>
          )}
          {tooltip && (
            <Tooltip title={tooltip}>
              <InfoOutlinedIcon
                sx={{
                  fontSize: 18,
                  marginLeft: 1, // Add spacing between title and icon
                  cursor: 'help', // Change cursor to indicate interactivity
                  color: 'grey.600', // Make the icon slightly subdued
                }}
              />
            </Tooltip>
          )}
        </Box>
        {actionIcon && onActionClick && (
          <IconButton
            size="small"
            onClick={onActionClick}
            sx={{
              ml: 1,
            }}
          >
            {actionIcon}
          </IconButton>
        )}
      </Box>
    </Stack>
  );
};

export default SectionTitle;
